function getRegulator(SHA256) {
  if (SHA256 == '5ed56a95c427f931f9b5288e567287a486aefa2bb8305c89eea036d16f05de54') return 'cima'
  else if (SHA256 == '3edb66ea075e148507b4547497333f55f63218596ac3acdad9eb49f8ce686f4c') return 'svg'
  else return 'cima'
}

export { getRegulator }
